"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteFolder = exports.DeleteFolder = exports.DeleteFolderActionTypes = exports.updateFolder = exports.UpdateFolder = exports.UpdateFolderActionTypes = exports.createFolder = exports.CreateFolder = exports.CreateFolderActionTypes = exports.FolderActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _fluxActions = require("flux-actions");

var FolderActionTypes = (0, _namespacedKeyMirror.default)({
  CREATE_FOLDER: null,
  UPDATE_FOLDER: null,
  DELETE_FOLDER: null
}, 'folders');
exports.FolderActionTypes = FolderActionTypes;
var CreateFolderActionTypes = (0, _actions.createRequestTypes)(FolderActionTypes.CREATE_FOLDER);
exports.CreateFolderActionTypes = CreateFolderActionTypes;
var CreateFolder = (0, _actions.createRequestActions)(CreateFolderActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateFolderActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text("sales.products.folders.alerts.create.success")));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateFolderActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text("sales.products.folders.alerts.create.error")));
  }
});
exports.CreateFolder = CreateFolder;
var createFolder = (0, _fluxActions.createAction)(FolderActionTypes.CREATE_FOLDER, (0, _actions.mapPayloadTo)('data'));
exports.createFolder = createFolder;
var UpdateFolderActionTypes = (0, _actions.createRequestTypes)(FolderActionTypes.UPDATE_FOLDER);
exports.UpdateFolderActionTypes = UpdateFolderActionTypes;
var UpdateFolder = (0, _actions.createRequestActions)(UpdateFolderActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateFolderActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text("sales.products.folders.alerts.update.success")));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateFolderActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text("sales.products.folders.alerts.update.error")));
  }
});
exports.UpdateFolder = UpdateFolder;
var updateFolder = (0, _fluxActions.createAction)(FolderActionTypes.UPDATE_FOLDER, (0, _actions.mapPayloadTo)('data'));
exports.updateFolder = updateFolder;
var DeleteFolderActionTypes = (0, _actions.createRequestTypes)(FolderActionTypes.DELETE_FOLDER);
exports.DeleteFolderActionTypes = DeleteFolderActionTypes;
var DeleteFolder = (0, _actions.createRequestActions)(DeleteFolderActionTypes);
exports.DeleteFolder = DeleteFolder;
var deleteFolder = (0, _fluxActions.createAction)(FolderActionTypes.DELETE_FOLDER, (0, _actions.mapPayloadTo)('data'));
exports.deleteFolder = deleteFolder;